import React from 'react';

function Sort({ sortOptions, handleSortChange, selected }) {
  return (
    <div className='sort'>
      <label htmlFor='sort' className='visually-hidden'>Sort by</label>
      <select id='sort' onChange={handleSortChange} value={selected}>
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  );
}

export default Sort;
